import Experience from "./experience/Experience";

// Canvas
const canvas = document.querySelector('canvas.webgl')

new Experience(canvas);
